import { gql } from '@apollo/client';

export const GET_TOOL_USER_FAVORITE = gql`
  query GetToolUserFavorites($toolUserFavoriteInput: ToolUserFavoriteInput) {
    getToolUserFavorites(toolUserFavoriteInput: $toolUserFavoriteInput) {
      toolUserFavorites {
        id
        toolCatalogId
        projectId
      }
      error
    }
  }
`;

export const CREATE_TOOL_USER_FAVORITE = gql`
  mutation CreateToolUserFavorite($createToolUserFavoriteInput: CreateToolUserFavoriteInput!) {
    createToolUserFavorite(createToolUserFavoriteInput: $createToolUserFavoriteInput) {
      data {
        id
        toolCatalogId
        userId
        projectId
      }
      error
    }
  }
`;

export const REMOVE_TOOL_USER_FAVORITE = gql`
  mutation RemoveToolUserFavorite($id: ID!) {
    removeToolUserFavorite(toolUserFavoriteId: $id) {
      data {
        id
        toolCatalogId
        userId
        projectId
      }
      error
    }
  }
`;

export const SEARCH_TOOL_USER_FAVORITE = gql`
  query SearchToolUserFavorites($searchInput: SearchInput) {
    searchToolUserFavorites(searchInput: $searchInput) {
      items {
        id
        toolCatalogId
        toolCatalog {
          id
          bscnPartNumber
          name
          toolCatalogImageUrl
          toolCategory {
            id
            name
          }
        }
      }
    }
  }
`;

export const DELETE_TOOL_USER_FAVORITE = gql`
  mutation DeleteToolUserFavorite($toolUserFavoriteId: ID!) {
    deleteToolUserFavorite(toolUserFavoriteId: $toolUserFavoriteId) {
      id
    }
  }
`;

export const SAVE_USER_FAVORITE = gql`
  mutation SaveToolUserFavorites($input: SaveToolUserFavoriteInput!) {
    saveToolUserFavorites(input: $input) {
      error
      recordsAffected
    }
  }
`;
